import React, {useState, useEffect} from 'react';
import './style.sass';
import { useHistory } from 'react-router-dom';

import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import { MenuCredito } from 'components/menuCredito';
import { useIsMobile } from 'hooks/useIsMobile';
import Loading from 'components/Loading';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { decodeStorage } from 'functions/storageBase64'

import { BtnPagoSpei } from 'pages/Credito/3-PagarTarjeta/PagoSpei/ModulosPagoSpei'


export function ElegirFormaPagoNew(props) {
    const {
        errorCode
    } = props

    const history = useHistory();
    const { isMobile } = useIsMobile();
    const [loading, setLoading] = useState(false)
    const payCardRelation = decodeStorage('payCardRelation')

    useEffect(() => {
        if (!payCardRelation) {
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-tarjeta`);
        }
    }, [])
    
    
    const clickTienda=()=>{
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-en-tienda`);
    }

    const clickTarjeta=()=>{
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/agregar-tarjeta-bancaria`);
    }  

    return (
        <>
            {loading && <Loading />}
            <div className='addMethodPay'>
                <h2 className="h2">Otras formas de pago</h2>
                <div className='formasPago'>
                    <ul>
                        {errorCode != 412
                            ?
                                <>
                                    <li className='tarjetas' onClick={clickTarjeta}>Tarjetas de Crédito y Débito <div className="smallText">Se verá reflejado en máximo 48 hrs.</div></li>
                                    <BtnPagoSpei loading={setLoading} />
                                </>
                            : null
                        }
                        <li className='tienda' onClick={clickTienda}>Pago en tienda Sears / Sanborns</li>
                    </ul>
                </div>
            </div>
        </>
    )
}



export function ElegirFormaPago() {
    const history = useHistory();
    const { isMobile } = useIsMobile();
    const [loading, setLoading] = useState(false)
    const payCardRelation = decodeStorage('payCardRelation')

    useEffect(() => {
        if (!payCardRelation) {
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-tarjeta`);
        }
    }, [])
    
    
    const clickTienda=()=>{
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/pagar-en-tienda`);
    }

    const clickTarjeta=()=>{
        history.push(`${BASE_PATH}${SUB_DIRECTORY}pagar/agregar-tarjeta-bancaria`);
    }

    return (
        <>
            {loading && <Loading />}
            {isMobile
                ? isMobile === 'desktop'
                    ? <Header type="complete" />
                    : <HeaderMobileCredito title={"Elegir una forma de pago"} type="backFull" />
                : null
            }
            <div className="container">

                <div className="contCards">

                    <MenuCredito />
                    <div className="contArrayCards">
                        {isMobile
                            ? isMobile === 'desktop' &&
                            <h1 className="h1">Selecciona una forma de pago</h1>
                            : null
                        }

                        <div className='formasPago width100'>
                            <ul>
                                <li className='tarjetas' onClick={clickTarjeta}>Tarjetas de Crédito y Débito</li>
                                <BtnPagoSpei loading={setLoading} />
                                <li className='tienda' onClick={clickTienda}>Pago en tienda Sears / Sanborns </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            {isMobile
                ? isMobile === 'desktop'
                    ? <Footer type="complete"/>
                    : null
                : null
            }
        </>
    )
}